<div [formGroup]="form" *ngIf="isVisible">
  <form-field
    class="front mb-0 mt-3"
    label="New email address *"
    i18n-label="@@support.emailChangeTicket.newEmailAddress.label"
  >
    <input
      required
      type="email"
      formControlName="newEmailAddress"
      placeholder="Fill out the new email address"
      i18n-placeholder="@@support.emailChangeTicket.newEmailAddress.placeholder"
    />
  </form-field>
  <small
    i18n="@@support.required"
    class="text-danger"
    *ngIf="newEmailAddress?.errors?.required && newEmailAddress?.touched"
    >* This field is required.</small
  >
  <small
    i18n="@@support.validEmailError"
    class="text-danger"
    *ngIf="newEmailAddress?.errors?.email && newEmailAddress?.touched"
  >
    Please enter a valid email address.
  </small>
  <div class="row mt-3">
    <div class="col-lg-6">
      <file-uploader
        [maxSize]="1024 * 5"
        [allowedTypes]="['png', 'jpg', 'jpeg']"
        class="w-100"
        data-testid="support-selfie-input"
        (select)="onFileSelect($event, 'personalPhoto')"
        (remove)="onFileRemove('personalPhoto')"
      >
        <input
          #file
          type="file"
          class="input"
          required
          (click)="markAsTouched('personalPhoto')"
        />
        <ng-template #placeholder>
          <img src="assets/images/icons/upload-selfie.svg" alt="upload icon" />
          <div class="text-primary pt-2 text-sm" i18n="@@support.selfie.label">
            Selfie *
          </div>
        </ng-template>
      </file-uploader>
      <small
        i18n="@@support.required"
        class="text-danger"
        *ngIf="personalPhoto?.errors?.required && personalPhoto?.touched"
        >* This field is required.</small
      >
    </div>
    <div class="col-lg-6">
      <file-uploader
        [maxSize]="1024 * 5"
        [allowedTypes]="['png', 'jpg', 'jpeg']"
        data-testid="support-passport-input"
        class="w-100"
        (select)="onFileSelect($event, 'passport')"
        (remove)="onFileRemove('passport')"
      >
        <input
          #file
          type="file"
          class="input"
          required
          (click)="markAsTouched('passport')"
        />
        <ng-template #placeholder>
          <img
            src="assets/images/icons/upload-passport.svg"
            alt="upload icon"
          />
          <div
            class="text-primary pt-2 text-sm"
            i18n="@@support.emailChangeTicket.passport"
          >
            Passport Copy or ID *
          </div>
        </ng-template>
      </file-uploader>
      <small
        i18n="@@support.required"
        class="text-danger"
        *ngIf="passport?.errors?.required && passport?.touched"
        >* This field is required.</small
      >
    </div>
  </div>
  <form-field
    class="front textarea mb-0 mt-3"
    label="Ticket Message"
    i18n-label="@@support.message.label"
  >
    <textarea
      formControlName="message"
      placeholder="Enter your ticket message"
      rows="5"
      i18n-placeholder="@@support.message.placeholder"
    ></textarea>
  </form-field>
</div>
